import { render, staticRenderFns } from "./MonthlyHistoryPoints.vue?vue&type=template&id=e77234b2&scoped=true"
import script from "./MonthlyHistoryPoints.vue?vue&type=script&lang=js"
export * from "./MonthlyHistoryPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77234b2",
  null
  
)

export default component.exports